export const ramo = {
  "01": "RCA",
  "02": "TUTELA GIUDIZIARIA",
  "03": "R.C.G.",
  "04": "A.R.D.",
  "05": "DIARIA DA RICOVERO (RMA) / INFORTUNI - DIARIA DA RICOVERO (ITA)",
  "06": "C.A.R.",
  "07": "FURTO",
  "08": "RISCHI TECNOLOGICI",
  "09": "CRISTALLI",
  10: "INCENDIO",
  11: "RISCHI ATOMICI",
  12: "SERRE",
  13: "MORTALITA' BESTIAME",
  14: "PERDITE PECUNIARIE",
  15: "MALATTIE",
  16: "LEASING",
  17: "DANNI INDIRETTI",
  18: "ADB EX-INCENDIO",
  19: "ASSISTENZA IN VIAGGIO",
  "1A": "ASSISTENZA IN VIAGGIO PLUS",
  "1B": "PERSONA 360 (RMA) / ASSISTENZA ALLA PERSONA (ITA)",
  "1C": "GARANZIE ACCESSORIE - FORMULA UNO",
  "1D": "GARANZIE ACCESSORIE - FORMULA DUE",
  "1E": "GARANZIE AGGIUNTIVE",
  "1F": "ASSISTENZA IN VIAGGIO",
  "1G": "ASSISTENZA IN VIAGGIO PLUS",
  "1H": "OPZIONE RIMBORSO SICURO",
  "1I": "GUASTI MECCANICI",
  "1L": "MERCI TRASPORTATE",
  "1M": "BUSINESS PLUS - DANNI AL VEICOLO O ALLE COSE TRASPORTATE",
  "1N": "BUSINESS PLUS - DANNI ATTIVITA",
  "1O": "GARANZIA RICORSO TERZI DA INCENDIO",
  20: "VITA ORDINARIE",
  21: "FONDI COMUNI",
  22: "VITA COLLETTIVE",
  23: "PRESTITI",
  24: "VITA CESSIONE QUINTO",
  25: "RISCHIO IMPIEGO",
  26: "COLLETTIVE A.I.L.",
  27: "VITA RENDITE",
  28: "INTERESSI TECNICI",
  29: "CAPITALIZZAZIONI",
  "2A": "VITA",
  "2B": "FONDI PENSIONE",
  30: "CORPI DI VEICOLI FERROVIARI",
  35: "GRANDINE",
  36: "GRANDINE",
  40: "INCENDIO/FURTO",
  41: "FURTO VEICOLI",
  42: "INCENDIO VEICOLI",
  43: "MINI-GUASTI",
  44: "GUASTI",
  45: "RITIRO PATENTE",
  46: "FURTO NATANTI",
  47: "INCENDIO NATANTI",
  48: "CRISTALLI",
  49: "PERDITA TOTALE NATANTI",
  "4A": "EVENTI NATURALI",
  "4B": "EVENTI SOCIOPOLITICI",
  "4C": "GARANZIE SPECIALI",
  "4D": "CARICO-SCARICO CON MEZZI MECCANICI",
  "4E": "NUOVE GARNAZIE SPECIALI POST 1.5.96",
  "4F": "GUASTI MECCANICI",
  "4G": "GARANZIE SPECIALI POST 1.7.98",
  "4H": "FURTO TOTALE VEICOLI",
  "4J": "PIE2",
  "4K": "PIE2",
  "4L": "ATTI VANDALICI NAT.",
  "4M": "TUTELA GIUDIZIARIA (ASSISTENZA LEGALE)",
  "4N": "RIPRISTINO AIRBAG",
  "4P": "GARANZIA CRISTALLI LIMITATA",
  "4Q": "GARANZIE AGGIUNTIVE",
  "4R": "ATTI VANDALICI E DOLOSI DI TERZI",
  "4S": "CALAMITA' NATURALI",
  "4T": "GARANZIE AGGIUNTIVE (POST. 01/08/2006) (RMA) / GARANZIE AGGIUNTIVE POST 1/8/2006 RMA (ITA)",
  "4U": "G/ACC. FORMULA UNO",
  "4V": "G/ACC. FORMULA DUE",
  "4W": "EVENTI SOCIOPOLITICI",
  "4X": "OVER 65 - SCIPPO",
  "4Y": "OVER 65 - 1 INTERVEN",
  "4Z": "GAR. SPECIALE P.P",
  50: "CAUZIONI",
  55: "CREDITO",
  "5A": "GUASTI - INDENNIZZO GARANTITO / SICURO",
  "5B": "POLE POSITION RAMO CVT",
  "5C": "POLE POSITION RC TRASP",
  "5D": "POLE POSITION RAMO PP",
  "5E": "CRISTALLI (AUTOMIA) (RMA) / GARANZIE SPECIALI A CRISTALLI ED. 05/2009 (ITA)",
  "5F": "GARANZIE ACCESSORIE COMBINAZIONE 1",
  "5G": "GARANZIE ACCESSORIE COMBINAZIONE 2",
  "5H": "GUASTI INTEGRALE A PRIMO RISCHIO ASSOLUTO",
  "5I": "INDENNIZZO SICURO 2012 (ITA) (RMA) / INDENNIZZO SICURO 2012 (ITA)",
  "5J": "LINEA VERDE (RMA) / A TUTTO GAS (ITA) - RICORSO TERZI INCENDIO E DANNI BOX",
  "5K": "INDENNIZZO GARANTITO - CLIENTI RMA",
  "5L": "FURTO ED. 05/2009",
  "5M": "EVENTI SOCIOPOLITICI ED. 05/2009",
  "5N": "EVENTI NATURALI ED. 05/2009",
  "5P": "GUASTI GARANZIA A ED. 05/2009",
  "5Q": "GUASTI GARANZIA B ED. 05/2009",
  "5R": "EVENTI SOCIOPOLITICI E NATURALI ED. 05/2009",
  "5S": "BUSINESS - PLATEAU ROYAL (ITA) (RMA) / BUSINESS - PLATEAU ROYAL (ITA)",
  "5T": "BUSINESS - CRISTALLI (ITA) (RMA) / BUSINESS - CRISTALLI (ITA)",
  "5U": "BUSINESS - PACCHETTO B (ITA) (RMA) / BUSINESS - PACCHETTO B (ITA)",
  "5V": "A TUTTO GAS - PACCHETTO A (ITA) (RMA) / A TUTTO GAS - PACCHETTO A (ITA)",
  "5W": "COLLISIONE PRIMO RISCHIO ASSOLUTO (ITA) (RMA) / COLLISIONE PRIMO RISCHIO ASSOLUTO (ITA)",
  "5X": "GARANZIA AGGIUNTIVE (CAMPER ITA) (RMA) / GARANZIE AGGIUNTIVE (IN PRIMA CLASSE CAMPER) (ITA)",
  "5Y": "INDENNITA' PATENTE",
  60: "INCENDIO 60",
  61: "RITIRO PRODOTTI",
  62: "DEC.POSTUMA",
  63: "INC. DANNI INDIRETTI",
  64: "RC MARITTIMI DA AUTO",
  65: "RC MARITTIMI DA RCG",
  66: "RC MULTIMODALE",
  67: "CORPI V. MARITTIMI DA TRASP.",
  68: "MERCI TRASPORTATE",
  69: "RC VETTORE",
  "6A": "GARANZIE ACCESSORIE - CAMPER REM",
  "6B": "DANNI INDIRETTI LOSSO OF PROFIT ITA-REM",
  "6C": "PACCHETTO PREMIUM - PERDITE PECUNIARIE",
  "6D": "RITIRO PATENTE",
  "6E": "DANNI DA SCASSO",
  "6F": "COLLISIONE CON ANIMALI SELVATICI UNGULATI",
  "6G": "FORMULA UNO ED. 06/2012",
  "6H": "FORMULA DUE ED. 06/2012",
  "6I": "GARANZIE AGGIUNTIVE ED. 06/2012",
  "6L": "GARANZIA GAP",
  "6M": "KASCO A PRIMO RISCHIO ASSOLUTO",
  "6O": "SPECIALE DIFESA (RMA) / ZERO IMPREVISTI (ITA)",
  "6P": "COLLISIONE CON VEICOLI ESTERI",
  "6Q": "COLLISIONE CON ANIMALI SELVATICI UNGULATI",
  "6X": "EX R.C. DECENNALE PO",
  "6Y": "INFORTUNI COMPLEM.",
  70: "MERCI AEREE",
  71: "INF. AERONAUTICI",
  72: "RISCHI ATOMICI 72 - DA INCENDIO",
  75: "CORPI DI VEICOLI AEREI",
  76: "AERONAUTICA",
  80: "PIE2",
  81: "PIE2",
  82: "PIE2",
  83: "PIE2",
  84: "PIE2",
  85: "PIE2",
  86: "PIE2",
  87: "PIE2",
  "8A": "LINEA VERDE - ASSISTENZA IN VIAGGIO (RMA) / A TUTTO GAS - ASSISTENZA IN VIAGGIO (ITA)",
  "8B": "LINEA VERDE - TUTELA LEGALE (RMA) / A TUTTO GAS - TUTELA LEGALE (ITA)",
  "8C": "TUTELA LEGALE - GARANZIA ESTESA",
  "8D": "TUTELA LEGALE - GARANZIA RIDOTTA",
  "8E": "BUSINESS - ASSISTENZA VIAGGIO (ITA) (RMA) / BUSINESS - ASSISTENZA VIAGGIO (ITA)",
  "8F": "BUSINESS - ASSISTENZA LEGALE ELITE (ITA) (RMA) / BUSINESS - ASSISTENZA LEGALE ELITE (ITA)",
  "8G": "PACCHETTO PREMIUM - ASSISTENZA IN VIAGGIO",
  "8H": "PACCHETTO PREMIUM - INFORTUNI",
  "8I": "ASSISTENZA IN VIAGGIO EXTRA",
  "8J": "INFORTUNI DEL CONDUCENTE - MORTE",
  "8K": "INFORTUNI DEL CONDUCENTE - INVALIDITA' PERMANENTE",
  "8L": "INFORTUNI DEL CONDUCENTE - DIARIA DA RICOVERO",
  "8M": "INFORTUNI DEL CONDUCENTE - SPESE DI CURA",
  "8N": "INFORTUNI DEL CONDUCENTE - RENDITA 4X4",
  "8P": "ASSISTENZA VEICOLI IBRIDI-ELETTRICI",
  "8Q": "FORMULA 2 (AUTOSTORICA)",
  "8R": "ASSISTENZA PLUS VEICOLI IBRIDI - ELETTRICI",
  91: "FONDO DI GARANZIA",
  92: "UCI",
  93: "CE",
  96: "NATANTI RCA BIS",
  99: "RAMO FITTIZIO",
  A1: "NUOVA COLLISIONE",
  D1: "DONNA ASSISTENZA",
  D2: "NUOVA DONNA PRIMO INTERVENTO (RMA) / DONNA PRIMO INTERVENTO (ITA)",
  D3: "DONNA DEGENZA",
  D4: "OVER 65 - ASSISTENZA",
  D5: "OVER 65 - DEGENZA",
  D6: "POLE POSITION ASSISTENZA",
  D7: "ASSISTENZA SPECIAL",
  G1: "MINI GUASTI",
  G2: "MAXI GUASTI",
  X1: "TUTELA GIUDIZIARIA DA 01.01.2007 (RMA) / TUTELA LEGALE DA 01.01.2007 (ITA)",
  X2: "ASSISTENZA LEGALE COMPLEMENTARE",
  X3: "ASSISTENZA LEGALE ESTESA",
  X4: "TUTELA LEGALE - GARANZIA BASE (RMA) / ASSISTENZA LEGALE BASE (ITA)",
  X5: "ASSISTENZA LEGALE ELITE",
  X6: "TUTELA LEGALE - VITA PRIVATA",
  X9: "ASSISTENZA IN NAVIGAZIONE (RMA) / ASSISTENZA NAVIGAZIONE (ITA)",
  YY: "DIRITTI AUTO",
  ZZ: "Tipo Garanzia Auto e D-Ramo Transitoria",
};
